import { render, staticRenderFns } from "./IntegratorRefreshAllManagementConfigTab.vue?vue&type=template&id=08b1280f"
import script from "./IntegratorRefreshAllManagementConfigTab.vue?vue&type=script&lang=ts"
export * from "./IntegratorRefreshAllManagementConfigTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports